/**
 * RTK Query cache tags for different API domains
 */
export const API_TAGS = {
  AUTH: 'Auth',
  LAYOUT: 'Layout',

  DASHBOARD: 'Dashboard',
  STORAGE: 'Storage',
  TRANSPORT: 'Transport',
  SERVICE_USERS: 'ServiceUsers',
  MAPPING: 'Mapping',
  OPTIONS: 'Options',
  LOCATIONS: 'Locations',
  ORGANIZATIONS: 'Organizations',
  CONSIGNMENTS: 'Consignments',
  CONTACTS: 'Contacts',
  COUNTRIES: 'Countries',
  CONSIGNMENT_HISTORY: 'ConsignmentHistory',
  LISTS: 'Lists',
  SERVICE_REQUESTS: 'ServiceRequests'
} as const;

export type ApiTag = (typeof API_TAGS)[keyof typeof API_TAGS];
